import React from "react";
import { BoxLightIcon } from "@/components/icons";

export default function EmptyProductList() {
  return (
    <div className="w-full min-h-[300px] flex flex-col justify-center items-center gap-2">
      <BoxLightIcon className="text-gray-400" />
      <p className="font-bold text-gray-400 text-base">
        Hiện chưa có sản phẩm!
      </p>
    </div>
  );
}
